import { OverlayTrigger } from "react-bootstrap";

import TikTok from "../../../assets/images/tiktok.svg";

const AvailableForTikTok = () => {
	return (
		<OverlayTrigger
			placement="right"
			overlay={
				<div className="tiktok-status-overlay">
					This product is verified for TikTok
				</div>
			}
		>
			<img
				className="cursor-pointer"
				style={{
					paddingRight: "5px",
				}}
				width={25}
				src={TikTok}
				alt=""
			/>
		</OverlayTrigger>
	);
};

export default AvailableForTikTok;
